namespace UUri {
  // Match all schemes including https://, mailto:, tel:
  export const hasScheme = (uri: string) => /^\w+:/.test(uri);
}

export default UUri;
